export default __webpack_public_path__ + "static/media/suggested-vat-10.446e771a.png";